import React from "react";
import {
  Row,
  Col,
  Space,
  message,
  Button,
  Modal,
  Image,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";
import TaxiDefaultParameterStore from "../store/TaxiDefaultParameterStore";
import TaxiDefaultParameterAdd from "./TaxiDefaultParameterAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import { CloseOutlined } from "@ant-design/icons";
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 230;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 140;
    } else if (val.title?.length > 8) {
      val.width = 130;
    } else {
      val.width = 90;
    }
  });

  return arr;
};
class TaxiDefaultParameters extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.taxiDefaultParaStore = new TaxiDefaultParameterStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      comp_value: "",
      listDataUpdate: false,
      openTaxiForm: false,
      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = widthAdderFunc([
      {
        title: context.translate("_DAY_TIME_FROM_"),
        dataIndex: "dayTimeFrom",
        width: 14,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_DAY_TIME_TO_"),
        dataIndex: "dayTimeTo",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_SPEED_DISTANCE_"),
        dataIndex: "Speed_Distance",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_MAX_SPEED_1"),
        dataIndex: "maxSpeed",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_MAX_SPEED_INTERVAL_SEC_"),
        dataIndex: "maxSpeedInterval",
        width: 14,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DIGITAL_INPUT_1"),
        dataIndex: "DigitalInput1",
        width: 9,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DIGITAL_INPUT_2"),
        dataIndex: "DigitalInput2",
        width: 9,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DIGITAL_INPUT_3"),
        dataIndex: "DigitalInput3",
        width: 9,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DIGITAL_INPUT_4"),
        dataIndex: "DigitalInput4",
        width: 9,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_FLEET_DASHBORD_SETTING_FUELVOLUME1_"),
        dataIndex: "analogInput1",
        width: 8,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_FLEET_DASHBORD_SETTING_FUELVOLUME2_"),
        dataIndex: "analogInput2",
        width: 8,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_PRINTER_"),
        dataIndex: "printer",
        width: 6,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 5,
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Tooltip
                    placement="bottom"
                    // title="Delete Record"
                    title={this.context.translate("_DELETE_RECORD_")}
                    color={config.tooltipColorDelete}
                  >
                    <DeleteFilled style={{ color: config.deleteColor }} />
                  </Tooltip>
                </DeleteConfirm> */}
                <Tooltip
                  title={this.context.translate("_EDIT_RECORD_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: "19px",
                      width: "14px",
                      borderRadius: "0px",
                      cursor: "pointer",
                    }}
                    src={editIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      await this.onEdit(record);
                    }}
                  ></Image>
                </Tooltip>

                <Tooltip
                  title={this.context.translate("_DELETE_RECORD_")}
                  placement="bottom"
                >
                  <Image
                    src={require("../assets/images/NewDesign/Delete.png")}
                    style={{ cursor: "pointer", width: "14px" }}
                    onClick={() =>
                      this.setState({
                        openDeleteModal: true,
                        deleteData: record,
                      })
                    }
                  ></Image>
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ]);
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setTaxiData = this.context.viewStateStore.taxiDefaultParaObject;
      setTaxiData =
        typeof setTaxiData === "number" ? setTaxiData : setTaxiData.companyId;
      console.log(setTaxiData);
      if (setTaxiData !== "") {
        await this.taxiDefaultParaStore.loadData({
          companyId: setTaxiData,
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          page: this.state.currentPage,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setTaxiData
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          comp_value: singleData,
          // companyId: setTaxiData.companyId,//setTaxiData,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setTaxiDefaultParaStates({
      companyId: record.companyId,
    });
    await this.setState({ parameterId: record.parameterId });
    await this.setState({ openTaxiForm: true });
  };

  async onDelete(record) {
    const response = await this.taxiDefaultParaStore.deleteRecord({
      parameterId: record.parameterId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.taxiDefaultParaStore.loadData({
      companyId: this.state.companyId,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      page: this.state.currentPage,
    });
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    console.log(singleData);

    await this.setState({ comp_value: singleData });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  closeModal = () => {
    this.setState({ openTaxiForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openTaxiForm: false });
      await this.handleSearch();
    }
  };
  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.taxiDefaultParaStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  value={this.state.comp_value ? this.state.comp_value : null}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={6}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "40px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              <Button
                className="addButtonClass"
                onClick={() =>
                  this.setState({ openTaxiForm: true, parameterId: "" })
                }
              >
                <Image
                  style={{ marginInlineEnd: "5px", width: 13 }}
                  src={require("../assets/images/NewDesign/plus (Stroke).png")}
                ></Image>
                {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
              </Button>
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.taxiDefaultParaStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.taxiDefaultParaStore?.taxiParameterList}
            loading={this.taxiDefaultParaStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openTaxiForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal"
          //   title={this.context.translate("_TAXI_DEFAULT_PARAMETERS_DETAILS_")}
          //   centered
          //   open={this.state.openTaxiForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openTaxiForm: false, parameterId: "" });
          //   }}
          //   width={665}
          // >
          //   <div>
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openTaxiForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_TAXI_DEFAULT_PARAMETERS_DETAILS_")}
                <p className="formDescription">
                  {this.context.translate("_TAXI_DEFAULT_PARAMETERS_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openTaxiForm: false })}
            onCancel={() =>
              this.setState({ openTaxiForm: false, parameterId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <TaxiDefaultParameterAdd
                parameterId={this.state.parameterId}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
TaxiDefaultParameters.contextType = StoreContext;
export default observer(withRouter(TaxiDefaultParameters));
